// extracted by mini-css-extract-plugin
export default {"container":"gF-z","heading":"hF-z","text":"iF-z","info":"jF-z","link":"kF-z","fullMaxWidth":"lF-z"};